import { render, staticRenderFns } from "./TransfersStep2.vue?vue&type=template&id=961902f2&scoped=true"
import script from "./TransfersStep2.vue?vue&type=script&lang=js"
export * from "./TransfersStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961902f2",
  null
  
)

export default component.exports